import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white sales-pos-location-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-13 d-block mb-5 text-uppercase" }, " Planejado X Consolidado ")
], -1)
const _hoisted_5 = { class: "card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-muted me-8" }, "Visão", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: "qtdeContratos",
  class: "fw-medium"
}, "Qtde Contratos", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  value: "vlrContratos",
  class: "fw-medium",
  selected: ""
}, "Valor Contratos", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: "vlrMensal",
  class: "fw-medium"
}, "Valor Mensal", -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  id: "weeklySalesChart",
  class: "chart"
}

import { defineComponent, reactive, watch, computed, ref } from "vue";

import * as serviceDashboard from "@/services/DashboardInvestidor";
import ApexCharts from "apexcharts";

 interface IProps {
    planejado: serviceDashboard.PrevisaoDTO[],
    previsao: serviceDashboard.PrevisaoDTO[]
  }


export default /*#__PURE__*/_defineComponent({
  __name: 'WeeklySales',
  props: {
    planejado: {},
    previsao: {}
  },
  setup(__props: any) {

var props = __props;
  
var controle = reactive({
  visao: "vlrContratos",
    sales: [
      {
        name: "Planejado",
        data: [10,20,30,40,50,60,70,80],
      },
      {
        name: "Consolidado",
        data: [10,20,30,40,50,60,70,80],
      },
    ],
    weeklySalesChart: {
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "smooth",
      },
      colors: ["#6560F0", "#6FD3F7"],
      legend: {
        position: "top",
        fontSize: "14px",
        fontWeight: 500,
        horizontalAlign: "center",
        fontFamily: "Red Hat Display, sans-serif",
        labels: {
          colors: "#8E8DA1",
        },
        markers: {
          offsetY: -1,
          offsetX: -4,
          height: 15,
          width: 15,
        },
        itemMargin: {
          horizontal: 10,
        },
      },
      grid: {
        show: true,
        strokeDashArray: 5,
        borderColor: "#d9e9ef",
      },
      tooltip: {
        style: {
          fontSize: "14px",
          fontFamily: "Red Hat Display, sans-serif",
        },
        y: {
          formatter: function (val: string) {
            return "$" + val + "K";
          },
        },
      },
      xaxis: {
        categories: props.planejado?.map(a=> a.mes),
        labels: {
          show: true,
          style: {
            fontFamily: "Red Hat Display, sans-serif",
            colors: "#9C9AB6",
            fontSize: "14px",
            fontWeight: 500,
          },
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        tooltip: {
          style: {
            fontFamily: "Red Hat Display, sans-serif",
            colors: "#2b2a3f",
            fontSize: "14px",
          },
        },
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            fontFamily: "Red Hat Display, sans-serif",
            colors: ["#9C9AB6"],
            fontSize: "14px",
            fontWeight: 500,
          },
        },
      },
    },
  });

watch(() => props.planejado, (newVal) => {
  controle.sales[0].data = newVal?.map(a => a.valorAcum);
});

watch(() => props.previsao, (newVal) => {
  controle.sales[1].data = newVal?.map(a => a.valorAcum);
});

const chartRef = ref();

function redefine(){
  console.log("redefinindo...");
  var newData = [] as number[] ;
  var newData2 = [] as number[] ;
  
  if (controle.visao == "qtdeContratos") {
    newData = props.planejado?.map(a => a.qtdeAcum) ?? [];
    newData2 = props.previsao?.map(a => a.qtdeAcum) ?? [];
  } else if (controle.visao == "vlrContratos") {
    newData = props.planejado?.map(a => a.valorAcum) ?? [];
    newData2 = props.previsao?.map(a => a.valorAcum) ?? [];
  } else if (controle.visao == "vlrMensal") {
    newData = props.planejado?.map(a => a.valor) ?? [];
    newData2 = props.previsao?.map(a => a.valor) ?? [];
  }

  chartRef.value?.updateSeries([
    { ...controle.sales[0], data: newData },
    { ...controle.sales[1], data: newData2 },
    
  ]);

  console.log("Dados atualizados");
  console.log(newData);
  console.log(newData2);
}



return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).visao) = $event)),
            class: "form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (redefine()))
          }, _hoisted_10, 544), [
            [_vModelSelect, _unref(controle).visao]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_apexchart, {
          ref_key: "chartRef",
          ref: chartRef,
          type: "line",
          height: "375",
          options: _unref(controle).weeklySalesChart,
          series: _unref(controle).sales
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}
}

})